{
  "version": "1.0",
  "builder": "rule",
  "stepperOrientation": "horizontal",
  "linear": false,
  "steps": [
    {
      "id": "intake",
      "label": "Analyze workbook",
      "sections": [
        { "id": "intake", "fields": [{ "field": "intake" }] }
      ]
    },
    {
      "id": "workspace",
      "label": "Workspace",
      "sections": [
        { "id": "workspace", "fields": [{ "field": "workspace" }] }
      ]
    }
  ],

  "options": {
    "acceptedFileTypes": ".xlsx"
  },

  "apiEndpoints": {
    "baseUrl": "",
    "uploadUrl": "",
    "chatUrl": "/ppt-dashboard/generate"
  }
}
